import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export const daysLongLabels = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const daysShortLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// "01" - "31"
export const daysOfMonth: string[] = Array.from({ length: 31 }, (_e, i) => (i + 1).toString().padStart(2, '0'));

export const hours = [
  { name: '05 AM', value: 5 },
  { name: '06 AM', value: 6 },
  { name: '07 AM', value: 7 },
  { name: '08 AM', value: 8 },
  { name: '09 AM', value: 9 },
  { name: '10 AM', value: 10 },
  { name: '11 AM', value: 11 },
  { name: '12 PM', value: 12 },
  { name: '01 PM', value: 13 },
  { name: '02 PM', value: 14 },
  { name: '03 PM', value: 15 },
  { name: '04 PM', value: 16 },
  { name: '05 PM', value: 17 },
  { name: '06 PM', value: 18 },
  { name: '07 PM', value: 19 },
  { name: '08 PM', value: 20 },
  { name: '09 PM', value: 21 },
  { name: '10 PM', value: 22 },
  { name: '11 PM', value: 23 },
  { name: '12 AM', value: 0 },
  { name: '01 AM', value: 1 },
  { name: '02 AM', value: 2 },
  { name: '03 AM', value: 3 },
  { name: '04 AM', value: 4 },
];

export const timeFormat = 'hh A';

export const dateFormat = (date: string | number | dayjs.Dayjs | Date | null | undefined) => {
  const format_date = dayjs(date);
  if (format_date.isValid()) {
    return format_date.format('MMM DD YYYY, h:mm a');
  }
  return '--';
};

export const dateTimeFormat = (date: string | number | dayjs.Dayjs | Date | null | undefined) => {
  const format_date = dayjs(date);
  if (format_date.isValid()) {
    return format_date.format('h:mm a');
  }
  return '--';
};

export const dateFormatToLocale = (date: Date, month: 'short' | 'long' = 'short'): string => {
  return date.toLocaleString(['en-US', 'en-CA'], {
    month: month,
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

export const dateFormatNoTimeToLocale = (date: Date): string => {
  return date.toLocaleString(['en-US', 'en-CA'], {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  });
};

export const dateFormatNoTime = (dateStr: string) => {
  const d = dayjs(dateStr);
  if (d.isValid()) {
    return dateFormatNoTimeToLocale(d.toDate());
  }
  return '--';
};
